<div class="raised-by">
  <div *ngIf="currency" class="amount-value">
    <span><app-currency-icon [currency]="currency"></app-currency-icon>
      {{summaryDetails?.raised?.raised | inrFormat:currency}}</span> raised by <span>{{summaryDetails?.raised?.backers}}</span> supporters
  </div>
</div>